import React from "react";
import Chart from "react-apexcharts";
import { Form } from "react-bootstrap";

const ManualVsSystemQueries = ({ analytics = {} }) => {
  const categories = [
    "Coding review",
    "SDV review",
    "Safety review",
    "Manual CRA query",
    "Manual DM query",
    "Data reconciliation",
    "Protocol deviation review",
    "SAE reconciliation",
    "Medical review",
    "System edit check",
    "External lab reconciliation",
  ];

  const values = [99, 99, 94, 84, 82, 76, 75, 74, 73, 71, 71];

  // Blue = Manual
  // Gray = System
  const colors = [
    "#2f66e0",
    "#2f66e0",
    "#2f66e0",
    "#2f66e0",
    "#2f66e0",
    "#94a3b8",
    "#2f66e0",
    "#2f66e0",
    "#2f66e0",
    "#94a3b8",
    "#94a3b8",
  ];

  const options = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        borderRadius: 4,
        barHeight: "72%",
      },
    },

    colors,

    legend: {
      show: false,
    },

    dataLabels: {
      enabled: false,
    },

    stroke: {
      width: 0,
    },

    xaxis: {
      categories,
      min: 0,
      max: 100,
      tickAmount: 5,
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },

    yaxis: {
      labels: {
        style: {
          fontSize: 12,
        },
      },
    },

    grid: {
      borderColor: "#e2e8f0",
      strokeDashArray: 0,
    },

    tooltip: {
      y: {
        formatter: (value) => `${value}%`,
      },
    },
  };

  const series = [
    {
      name: "Queries",
      data: values,
    },
  ];

  return (
    <>
      <div className="p-3">
        <Chart options={options} series={series} type="bar" height={280} />
      </div>
    </>
  );
};

export default ManualVsSystemQueries;
